import React, { useCallback } from "react";
import { EditableText, Tooltip } from "@activecollab/components";
import PropTypes from "prop-types";

export const EditableSummary = ({ summary, onChange, ...rest }) => {
  const handleChangeSummary = useCallback(
    (e) => {
      if (typeof onChange === "function") onChange({ summary: e.target.value });
    },
    [onChange]
  );

  return (
    <Tooltip
      title={summary}
      disable={summary.length < 40}
    >
      <EditableText
        value={summary}
        onSave={handleChangeSummary}
        allowEmptyString
        multiline
        {...rest}
      />
    </Tooltip>
  );
};

EditableSummary.propTypes = {
  summary: PropTypes.string,
  onChange: PropTypes.func,
};
